import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Location, NgIf, NgFor } from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import {AuthService} from '../../core/security/auth.service';
import {ProMessagingWhatsAppTemplateService} from '../pro-messaging-whats-app-template.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {
  CurrentUser,
  LookupModel,
  WhatsAppMessagingTemplateModel,
  WhatsAppTemplateButtonModel,
  WhatsAppTemplateComponentModel
} from '../../api/models';
import {MatConfirmDialogComponent} from '../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {LanguageHelper} from '../../core/utilities/language-helper';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatTextareaInputComponent } from '../../editors/mat-textarea-input/mat-textarea-input.component';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

@Component({
    selector: 'app-pro-messaging-whats-app-template-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatCard,
        MatCardTitle,
        MatCardContent,
        FlexModule,
        NgIf,
        MatSimpleSelectComponent,
        MatTextInputComponent,
        MatTextareaInputComponent,
        NgFor,
        MatPhoneNumberInputComponent,
        MatIconButton,
        MatIcon,
        MatButton,
        MatCardActions,
        MatTooltip,
        Angular2PromiseButtonModule,
    ],
})
export class ProMessagingWhatsAppTemplateEditComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Output() afterSaveOrDelete: EventEmitter<WhatsAppMessagingTemplateModel> = new EventEmitter();
  @Input() id: string;
  popupMode = false;

  languageLookup = LanguageHelper.getLanguagesLookup();

  form: UntypedFormGroup;
  wabaIdControl = new UntypedFormControl('', [Validators.required]);
  nameControl = new UntypedFormControl('', [Validators.required]);
  categoryControl = new UntypedFormControl('', [Validators.required]);
  languageControl = new UntypedFormControl('', [Validators.required]);

  // header
  headerFormatControl = new UntypedFormControl('NONE', [Validators.required]);
  headerTextControl = new UntypedFormControl('', []);
  // body
  bodyTextControl = new UntypedFormControl('', [Validators.required]);
  // footer
  footerTextControl = new UntypedFormControl('', []);
  // buttons
  buttonsTypeControl = new UntypedFormControl('NONE', [Validators.required]);

  hasPublicEditAccess = false;
  hasPrivateEditAccess = false;
  submitted: boolean;
  serverError: boolean;
  wabaIdsLookup: Array<LookupModel> = [];
  model: WhatsAppMessagingTemplateModel = {
    name: '',
    id: 'new',
    components: [],
    category: '',
    language: 'en_EN',
    status: 'PENDING',
    wabaId: '',
    wabaTemplateId: '',
    phoneNumber: ''
  };
  buttonSubmitPromise: Promise<void>;
  private paramsSubscription;

  constructor(route: ActivatedRoute, titleService: Title, headerService: HeaderService, authService: AuthService,
              public dialog: MatDialog,
              public templateService: ProMessagingWhatsAppTemplateService,
              private changeDetectorService: ChangeDetectorRef,
              private fb: UntypedFormBuilder,
              private location: Location, private notificationService: NotificationService) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete,
      RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete];

    this.deleteRoles = [RolesEnum.MessagingTemplateDelete, RolesEnum.MessagingPrivateTemplateDelete];

    this.hasPublicEditAccess = this.hasAccess([RolesEnum.MessagingTemplateEdit, RolesEnum.MessagingTemplateDelete]);
    this.hasPrivateEditAccess = this.hasAccess([RolesEnum.MessagingPrivateTemplateEdit, RolesEnum.MessagingPrivateTemplateDelete]);

    this.paramsSubscription = this.route.params.subscribe(async (params) => {
      this.model = {
        name: '',
        id: params['id'],
        components: [],
        category: '',
        language: 'en_EN',
        status: 'PENDING',
        wabaId: '',
        wabaTemplateId: '',
        phoneNumber: ''
      };
      console.log(`${this.model.id}`);

      if (this.model.id !== 'new' && this.model.id) {
        this.model = await this.templateService.getTemplateById(this.model.id);
        this.resetForm();
      }
    });

    this.createForm();
  }

  async ngOnInit() {
    super.ngOnInit();

    this.headerService.showBackButton(true);

    this.ngOnChanges();
  }

  onCurrentUserChanged(user: CurrentUser) {
    super.onCurrentUserChanged(user);
    this.templateService.getWhatsAppNumbers().then((numbers) => {
      this.wabaIdsLookup = numbers;
    })

  }

  ngOnChanges() {
    const currentUser = this.authService.currentUser.getValue();
    this.templateService.getWhatsAppNumbers().then((numbers) => {
      this.wabaIdsLookup = numbers;
    })

    if (this.id) {
      this.popupMode = true;
      this.model = {
        name: '',
        id: this.id,
        components: [],
        category: '',
        language: 'en_EN',
        status: 'PENDING',
        wabaId: '',
        wabaTemplateId: '',
        phoneNumber: ''
      };
      // this.resetForm();
      if (this.model.id !== 'new') {
        this.templateService.getTemplateById(this.model.id).then((value) => {
          this.model = value;
          this.resetForm();
        });
      }
    } else {
      this.popupMode = false;
    }

    this.resetForm();
  }

  resetForm() {
    const headerObj = this.model.components.find(x => x.type === 'HEADER');
    const bodyObj = this.model.components.find(x => x.type === 'BODY');
    const footerObj = this.model.components.find(x => x.type === 'FOOTER');
    const buttonsObj = this.model.components.find(x => x.type === 'BUTTONS');

    let buttonsType = 'NONE';
    const buttons = buttonsObj?.buttons || [];
    if (buttons.length > 0) {
      if (buttons.findIndex(x => x.type === 'QUICK_REPLY') > -1) {
        buttonsType = 'QUICK_REPLY';
      } else {
        buttonsType = 'QUICK_ACTION';
      }
    }

    this.form.reset({
      name: this.model.name,
      category: this.model.category,
      language: this.model.language.replace('_', '-'),
      headerFormat: headerObj?.format || 'NONE',
      headerText: headerObj?.text,
      bodyText: bodyObj?.text,
      footerText: footerObj?.text,
      buttonsType: buttonsType,
      wabaId: this.model.wabaId
    });
    // this.changeDetectorService.markForCheck();

    if (buttons.length > 0) {
      this.setButtonsForm(buttons);
    }

    console.log(this.model.status);
    if ((this.model.id === 'new' && this.model.status === 'PENDING')
      || this.model.status === 'APPROVED'
      || this.model.status === 'REJECTED') {
      this.submitted = false;
      this.changeDetectorService.detectChanges();
    } else {
      this.submitted = true;
      this.changeDetectorService.detectChanges();
    }

    console.log('after form reset', this.model);
  }

  setButtonsForm(items: WhatsAppTemplateButtonModel[]) {
    const formGroups = items.map(item => this.fb.group({
      'type': [item.type],
      'text': [item.text],
      'url': [item.url],
      'phone_number': [item.phone_number],
    }));
    const formArray = this.fb.array(formGroups, []);
    this.form.setControl('buttons', formArray);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.showBackButton(false);
  }

  async onSubmit() {
    this.submitted = true;
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    } else {
      this.submitted = false;
    }
  }

  async processSubmit(): Promise<void> {

    try {
      const reqData = this.prepareFormModel();
      await this.templateService.saveTemplate(reqData);
      this.notificationService.notifySuccess('Record updated successfully');

      if (this.popupMode) {
        this.afterSaveOrDelete.emit(reqData);
      } else {
        this.goBack();
      }
    } catch (e) {
      this.serverError = true;
    } finally {
      this.submitted = false;
    }
  }

  prepareFormModel(): WhatsAppMessagingTemplateModel {
    const formModel = this.form.value;

    const components: Array<WhatsAppTemplateComponentModel> = [];
    if (formModel.headerFormat !== 'NONE') {
      components.push(
        {
          type: 'HEADER',
          format: formModel.headerFormat,
          text: formModel.headerText,
        }
      );
    }

    components.push(
      {
        type: 'BODY',
        text: formModel.bodyText,
      }
    );

    if (formModel.footerText) {
      components.push(
        {
          type: 'FOOTER',
          text: formModel.footerText,
        }
      );
    }

    if (formModel.buttonsType !== 'NONE') {
      const component: WhatsAppTemplateComponentModel = {
        type: 'BUTTONS',
        buttons: []
      };

      if (formModel.buttonsType === 'QUICK_REPLY') {
        for (const button of formModel.buttons) {
          component.buttons!.push({
            type: 'QUICK_REPLY',
            text: button.text
          });
        }
      }

      if (formModel.buttonsType === 'QUICK_ACTION') {
        for (const button of formModel.buttons) {
          component.buttons!.push({
            type: button.type,
            text: button.text,
            url: button.type === 'URL' ? button.url : undefined,
            phone_number: button.type === 'PHONE_NUMBER' ? button.phone_number : undefined,
          });
        }
      }

      components.push(component);
    }

    return {
      id: this.model.id,
      name: formModel.name.replace(' ', '_'),
      category: formModel.category,
      language: formModel.language.replace('-', '_'),
      status: this.model.status,
      wabaId: formModel.wabaId,
      wabaTemplateId: this.model.wabaTemplateId,
      components: components,
      phoneNumber: ''
    };
  }

  goBack(): void {
    this.location.back();
  }

  createForm(): void {
    this.form = this.fb.group({
        'name': this.nameControl,
        'wabaId': this.wabaIdControl,
        'category': this.categoryControl,
        'language': this.languageControl,
        'headerFormat': this.headerFormatControl,
        'headerText': this.headerTextControl,
        'bodyText': this.bodyTextControl,
        'footerText': this.footerTextControl,
        'buttonsType': this.buttonsTypeControl,
        'buttons': this.fb.array([], []),
      }
    );
  }

  get buttonsForm(): UntypedFormArray {
    return this.form.get('buttons') as UntypedFormArray;
  }

  async onDeleteClick() {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Template?',
        text: 'Are you sure you want to delete this template? Deleting template will delete all associated languages',
        actionTitle: 'Delete',
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.templateService.deleteTemplateById(this.model.id);
        await this.notificationService.notifySuccess('Template has been deleted successfully');
        if (this.popupMode) {
          this.afterSaveOrDelete.emit(undefined);
        } else {
          this.headerService.goBack();
        }
      }
    });
  }

  removeButton(index: number) {
    this.buttonsForm.removeAt(index);
  }

  addButton() {
    this.buttonsForm.push(this.fb.group({
      'type': [''],
      'text': [''],
      'url': [''],
      'phone_number': [''],
    }));
  }
}
